// components/ArticleList.tsx
import React, { use, useContext, useEffect } from 'react';
import { TFunction } from 'next-i18next';
import Texto from '@/components/elements/Texto';
import { Card, Rating } from '@mui/material';
import TextFieldCustom, { AutocompleteValues, InputTypes } from '@/components/elements/TextFieldCustom';
import ReviewsIcon from '@mui/icons-material/Reviews';
import { ComentarUsuarioObj, PuntuarUsuarioLibroObj } from '@/objects/Articles';
import { ServicesContext, useServices } from '@/context/ServicesProvider';
import { cargarDatosUsuario } from '@/util/LocalStorageLoaded';
import Boton from '../elements/Boton';
import SaveIcon from '@mui/icons-material/Save';
import { AxiosResponse } from 'axios';

interface ArticleListProps {
  puntuacionObj: PuntuarUsuarioLibroObj;
  t: TFunction;
}

//Son 5 estrellas y los puntos son del 0 al 10
const PRECISION = 0.5;

const PuntuarUsuario: React.FC<ArticleListProps> = ({ t, puntuacionObj }) => {

  const { articulosQueries } = useServices();
  const [puntuacion, setPuntuacion] = React.useState<number>(0);
  const [textoOpinion, setTextoOpinion] = React.useState<string>('');

  function enviarPuntuacion() {
    const objPuntuar: ComentarUsuarioObj = {
      id_user_puntua: Number(cargarDatosUsuario()?.id_user),
      id_user_puntuado: puntuacionObj.id_user_vende,
      id_articulo: puntuacionObj.id_articulo,
      titulo_articulo: puntuacionObj.Nombre,
      categoria_articulo: puntuacionObj.categoria_articulo,
      puntuacion: puntuacion ?? 0,
      comentario: textoOpinion ?? ""
    };
    //alert(JSON.stringify(objPuntuar));
    articulosQueries?.puntuarUsuario(objPuntuar).then((response: AxiosResponse<string>) => {
      //Carga la web /dashboard/puntuaciones
      //alert(JSON.stringify(response.data))
      if(response.status == 200) {
        window.location.href = "/dashboard/puntuaciones";
      }
    }
    ).catch((error: any) => {

    });
  }

  return (
    <Card style={{ padding: "20px", display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: "95%" }}>
      <section style={{ width: "100%" }}>
        <Texto>{t("menu:secciones.puntuaciones.descripcion_puntuar")}</Texto>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <TextFieldCustom focus={false} id="isbn" label={t("menu:secciones.puntuaciones.comentario")}
            value={textoOpinion}
            setValue={setTextoOpinion}
            multiline={true}
            minRows={3}
            required={false} autocomplete={AutocompleteValues.Off} inputType={InputTypes.Text}
            leftIcon={<ReviewsIcon />} />
        </div>
        <Texto>{t("menu:secciones.puntuaciones.puntuacion")}</Texto>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Rating name="controlled" value={puntuacion} onChange={(event, newValue) => {
            //alert(newValue)
            setPuntuacion(Number(newValue));
          }}
            precision={PRECISION} size={"large"} />
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: "20px", paddingBottom: "10px" }}>
          <Boton fullWidth startIcon={<SaveIcon />} texto={t("common:opciones.guardar")} onClick={enviarPuntuacion} />
        </div>
      </section>
    </Card>
  );
}

export default PuntuarUsuario;